module.exports = __webpack_public_path__ + "img/legal.a62c4bf5.png";